import React from 'react';

const DEFAULT_SITE_LOADER_PROPS = {
    position: 'fixed', // fixed | absolute | relative
    background: 'white',
    alignment: 'center',
    size: '4',
};

const SiteLoader = ({
    position = DEFAULT_SITE_LOADER_PROPS.position,
    background = DEFAULT_SITE_LOADER_PROPS.background,
    alignment = DEFAULT_SITE_LOADER_PROPS.alignment,
    size = DEFAULT_SITE_LOADER_PROPS.size,
}) => {

    const getAlignmentClass = () => {
        if (alignment === 'left') return 'me-auto my-auto';
        if (alignment === 'right') return 'ms-auto my-auto';
        return 'm-auto';
    };

    return (
        <div
            className={`position-${position} bg-${background} d-flex`}
            style={{ zIndex: '10000', top: 0, left: 0, right: 0, bottom: 0 }}
        >
            <i className={`fas fa-circle-notch fa-spin fs-${size}x text-primary ${getAlignmentClass()}`} />
        </div>
    );
};

export default SiteLoader;
